import React from "react";
import StarImg from "../../../images/icons/solid/star.svg";
import SVG from "react-inlinesvg";

const Star = ({ isGold }: { isGold: boolean }) => {
    const starClassName = isGold ? `text-warning-primary` : `text-info-primary`;
    return (
        <div className={starClassName}>
            <SVG src={StarImg.src} />
        </div>
    );
};

export default Star;
